import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getAttachmentName'
})
export class GetAttachmentNamePipe implements PipeTransform {
  transform(path: string): string {
    if (!path) {
      return '';
    }

    const segments = path.split('/');
    return segments[segments.length - 1];
  }
}
